import { useMutation } from '@apollo/client/react';

import DeleteModal from '@atom/components/common/DeleteModal';
import textConstants from '@atom/constants/textConstants';
import { USER_UPDATE } from '@atom/graph/user';
import { useNavigation } from '@atom/hooks/useNavigation';
import { Progress } from '@atom/mui';

import classes from './userHeader.module.css';

interface Props {
  open: boolean;
  onClose: () => void;
  userId: string;
}

const DeactivateUserModal = ({ open, onClose, userId }: Props) => {
  const [, { navigate }] = useNavigation();
  const [updateUser, { loading: updateLoading }] = useMutation(USER_UPDATE, {
    onCompleted: () => {
      navigate('/team');
    },
  });

  const confirm = () => {
    updateUser({
      variables: {
        input: {
          id: userId,
          isActive: false,
        },
      },
    });

    onClose();
  };

  return (
    <DeleteModal
      title="Deactivate User?"
      onConfirm={confirm}
      confirmText="Deactivate"
      onCancel={onClose}
      content={
        updateLoading ? (
          <Progress />
        ) : (
          <div className={classes.modalContent}>
            {textConstants.DEACTIVATE_USER_MODAL_COPY}
          </div>
        )
      }
      open={open}
    />
  );
};

export default DeactivateUserModal;
